import { render, staticRenderFns } from "./printReviewResults.vue?vue&type=template&id=ea18e12e&scoped=true"
import script from "./printReviewResults.vue?vue&type=script&lang=js"
export * from "./printReviewResults.vue?vue&type=script&lang=js"
import style0 from "./printReviewResults.vue?vue&type=style&index=0&id=ea18e12e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea18e12e",
  null
  
)

export default component.exports